import { render, staticRenderFns } from "./moreETG.vue?vue&type=template&id=6361fec3&lang=pug&"
import script from "./moreETG.vue?vue&type=script&lang=js&"
export * from "./moreETG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports